<!--
 * @Description: 作业管理 列表页
 * @Author: PF
 * @Date: 2022-09-23 11:53:25
 * @LastEditors: PF
 * @LastEditTime: 2025-04-08 10:43:58
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">作业</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
    <el-container >
      <el-header class="pl0 pr0">
        <!-- 搜索区域 BEGIN -->
        <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-input placeholder="课程名称" v-model="dataGrid.parms.kcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <!-- 搜索区域 END -->
        <!-- 按钮区域 BEGIN -->
        <div class="button-box">
          <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
          <el-button type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
        </div>
        <!-- 按钮区域 END -->
      </el-header>
      <el-main class="pl0 pr0">
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <el-table-column label="课程" prop="kcmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="作业名称" prop="zymc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <!-- 冻结列-Left END -->
          <el-table-column label="教学单元" prop="jxdybt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="教学内容" prop="jxnrbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="共享" prop="sfgx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <div @click="dataGrid.multipleSelection=[scope.row.id]; gongxiang()">
                <el-switch v-model="scope.row.sfgx" disabled  />
              </div>
            </template>
          </el-table-column>
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template #default="scope">
              <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
              <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
              <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
    </el-container>
      <template #footer>
        <div class="dialog-footer">
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, submitDataGridAction, submitExcel, exportExcel, downloadTemplate, loadSelect, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载 学期 下拉框
const xqData = ref()
loadSelect({
  url: '/api/v2/pdp/xueqi/list',
  data: xqData,
  order: 'sx',
  sort: 'asc',
  loadSuccess: function (res) {
    if (res.data.length) {
      res.data.forEach((item) => {
        if (item.sfdqxq === true) {
          dataGrid.value.parms.xqid = item.id
        }
      })
    }
  }
})
// 加载 课程 下拉框
const kcData = ref()
loadSelect({ url: '/api/v2/jiaowu/kecheng/list', data: kcData, order: 'kch', sort: 'asc' })

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'scsj', order: 'descending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map(item => (item.id))
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/ziyuanku/zuoye/jiaoshi/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'zuoye') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

// 共享
const gongxiang = async () => {
  submitDataGridAction({
    url: '/api/v2/ziyuanku/zuoye/jiaoshi/gongxiangzuoye',
    dataGrid: dataGrid.value,
    method: 'post',
    callback: function (res) {
      bindTable()
    }
  })
}
// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/ziyuanku/zuoye/jiaoshi/delzuoye',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}
// Excel导入数据
const importInsert = async (file) => {
  submitExcel({
    url: '/api/v2/ziyuanku/zuoye/importInsert',
    file: file,
    callback: function (res) {
      bindTable()
    }
  })
}
// Excel更新数据
const importUpdate = async (file) => {
  submitExcel({
    url: '/api/v2/ziyuanku/zuoye/importUpdate',
    file: file,
    callback: function (res) {
      bindTable()
    }
  })
}
// Excel覆盖数据
const importCover = async (file) => {
  submitExcel({
    url: '/api/v2/ziyuanku/zuoye/importCover',
    file: file,
    callback: function (res) {
      bindTable()
    }
  })
}

// Excel导出
const exportData = async () => {
  exportExcel('/api/v2/ziyuanku/zuoye/export', dataGrid.value)
}

// 模板下载
const download = async () => {
  downloadTemplate('/api/v2/ziyuanku/zuoye/download')
}
</script>
